export default "__VITE_ASSET__CJRK$ZiK__"